import PredictiveNetworksTabs from "./PredictiveNetworksTabs";
import SubmenuHeaderView from "./SubmenuHeaderView";

const convergedPredictiveFilterDashlets = {
  filterDashlets: [
    {
      component: SubmenuHeaderView,
      name: "predictive-header",
      layout: { x: 0, y: 0, w: 12, h: 4 },
    },
    {
      component: PredictiveNetworksTabs,
      name: "predictive-tabs",
      layout: { x: 0, y: 4, w: 12, h: 4 },
    },
  ],
};

export default convergedPredictiveFilterDashlets;
